import {
  GET_LENDERS,
  GET_LENDERS_SUCCESS,
  GET_LENDERS_FAILURE,
  GET_LENDER,
  GET_LENDER_SUCCESS,
  GET_LENDER_FAILURE,
} from './constants';

const initialState = {
  lenders: { lenders: [], loading: false, loaded: false, error: null },
  lender: { lender: {}, loading: false, loaded: false, error: null },

}

const lenders = (state = initialState, action) => {
  switch (action.type) {
    case GET_LENDERS:
      return {
        ...state,
        lenders: { ...state.lenders, loading: true, loaded: false, error: null },
      };
    case GET_LENDERS_SUCCESS:
      return { 
        ...state,
        lenders: { lenders: action.payload, loading: false, loaded: true, error: null },
      };
    case GET_LENDERS_FAILURE:
      return {
        ...state,
        lenders: { ...state.lenders, loading: false, loaded: false, error: action.payload },
      };
    /* — GET LENDER — */
    case GET_LENDER:
      return {
        ...state,
        lender: { ...state.lender, loading: true, loaded: false, error: null },
      };
    case GET_LENDER_SUCCESS:
      return {
        ...state,
        lender: { lender: action.payload, loading: false, loaded: true, error: null },
      };
    case GET_LENDER_FAILURE:
      return {
        ...state,
        lender: { ...state.lender, loading: false, loaded: false, error: action.payload },
      };
      default:
      return state;
  }
};

export default lenders;
